import * as React from 'react';
const DoloriMestrualiIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-1{fill-rule:evenodd;stroke:${primaryColor ||
        '#282828'}}.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'}}`}</style>
    </defs>
    <path
      d="M60.06 139.03c-.61-2.88-1.21-5.98-1.81-9.5-5.96-35.18 4.93-41.62 12.38-68.56M139.94 139.03c.61-2.88 1.21-5.98 1.81-9.5 5.96-35.18-4.93-41.62-12.38-68.56M95.21 121.74c1.21 5.72 1.29 11.49.93 17.29M103.85 139.03c-.35-5.8-.27-11.58.93-17.29"
      className="prefix__cls-1"
    />
    <path
      d="M76.6 92.58c-4.59-1.91-9.43-4.35-14.69-7.3M138.09 85.28c-5.44 3.06-10.45 5.57-15.19 7.51M141.52 96.59c-15.91 4.77-29.56 13.67-36.75 25.15-1.07 1.67-2.98 2.29-4.78 2.3-1.8 0-3.71-.63-4.78-2.3-7.2-11.48-20.84-20.38-36.75-25.15"
      className="prefix__cls-1"
    />
    <circle cx={100} cy={85.66} r={8.66} className="prefix__cls-2" />
    <circle cx={100} cy={85.66} r={1.24} className="prefix__cls-2" />
    <circle cx={100} cy={85.66} r={16.14} className="prefix__cls-2" />
  </svg>
);
export default DoloriMestrualiIcon;
